export default "__VITE_ASSET__CZ3w_9B7__"